/**
 * Create config common to pie chart types
 */
export var createPieConfig = function (options) {
    return {};
};
